import React, { createContext, useContext, useState, useEffect } from 'react';

const BuildingContext = createContext();

export const useBuilding = () => {
  return useContext(BuildingContext);
};

export const BuildingProvider = ({ children }) => {
  const [selectedFloor, setSelectedFloor] = useState(parseFloat(localStorage.getItem('selectedFloor')) || 1);

  return (
    <BuildingContext.Provider value={{ selectedFloor, setSelectedFloor }}>
      {children}
    </BuildingContext.Provider>
  );
};
